<template>
  <div id="modalCheckOrder" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-md"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("distributor.审核采购单") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group row align-items-center">
              <label
                for="iptCooperateTitle"
                class="
                  col-md-3 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("distributor.采购单号：") }}</label
              >
              <div class="col-md-8 col-sm-12">
                <span>{{ item.code }}</span>
              </div>
            </div>
            <div class="form-group row align-items-center">
              <label
                for="iptCooperateTitle"
                class="
                  col-md-3 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("distributor.审核状态：") }}</label
              >
              <div class="col-md-8 col-sm-12">
                <select
                  v-model="itemDetail.type"
                  name="check"
                  id="check"
                  class="form-control form-control-sm"
                >
                  <option value="1">{{ $t("distributor.审核通过") }}</option>
                  <option value="2">
                    {{ $t("rm.审核拒绝并取消采购单") }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-if="itemDetail.type == 2"
              class="form-group row align-items-center"
            >
              <label
                for="iptCooperateTitle"
                class="
                  col-md-3 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                "
                >{{ $t("distributor.备注：") }}</label
              >
              <div class="col-md-8 col-sm-12">
                <textarea
                  v-model="itemDetail.result"
                  rows="3"
                  name="remindRemark"
                  id="remindRemark"
                  class="form-control form-control-sm"
                ></textarea>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="saveCheckOrder"
          >
            {{ $t("distributor.保存") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("distributor.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data: function () {
    return {
      itemDetail: {
        type: 1,
        result: "",
      },
    };
  },
  mounted() {
    $("#modalCheckOrder").on("hidden.bs.modal", (e) => {
      this.itemDetail.type = 1;
      this.itemDetail.result = "";
    });
  },
  methods: {
    saveCheckOrder() {
      let vm = this;
      let form = $("#modalCheckOrder form");
      form.validate({
        rules: {
          remindRemark: {
            required: true,
          },
        },
        messages: {
          remindRemark: {
            required: this.$t("distributor.审核失败原因必须输入"),
          },
        },
        ignore: "",
        errorElement: "span",
        errorClass: "ipt-error",
        errorPlacement: function (error, element) {
          let nextEl = $(element).next();
          if (nextEl.length) {
            $(element).parent().append(error);
          } else {
            error.insertAfter(element);
          }
        },
      });
      if (form.valid()) {
        let param = {
          code: this.item.code,
          type: this.itemDetail.type,
          remark: this.itemDetail.result,
        };
        this.$parent.loading = true;
        $.api_call(
          "api.SupplierPurchaseOrder.auditBySupplier",
          param,
          function (r) {
            vm.$parent.loading = false;
            if (r.ErrorCode == "9999") {
              ShowTip(vm.$t("distributor.审核成功"), "success");
              $("#modalCheckOrder").modal("hide");
              vm.$parent.getRMOrder();
              setTimeout(function () {
                vm.$parent.getRMStatusNum();
              }, 1500);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        );
      }
    },
  },
};
</script>
